// sih22

const sih1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/sih/sih/SIH-1.webp"
const sih2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/sih/sih/SIH-2.webp"
const sih3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/sih/sih/SIH-3.webp"
const sih4="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/sih/sih/SIH-4.webp"


export const sih22=[
    {
        id:1,
        heading:"Intelligent Innovators Hackathon",
        "sub-head":"",
        pic:sih1,
        link:"",
        content_1:"",
        content_2:"The Hackathon was conducted by Sri Eshwar College of Engineering, Coimbatore, Tamil Nadu on 04.11.2022 and 05.11.2022. Under the domain smart agriculture the team DEBUGGERS guided by Dr. K. Baskaran and Dr. C. Uma Rani have developed an application for farmers to post blogs. Additionally plant disease prediction and recommend crops based on the soil content features were integrated with the  developed application. The team DEBUGGERS have won the 1st prize with cash award of Rs. 50,000 along with shields and certificates"
    },
    {
        id:2,
        heading:" Team 1",
        "sub-head":"Grand Finale",
        pic:sih2,
        content_1:"",
        content_2:"The students have participated in the Grand finale of Smart India Hackathon held in Vageeswari College of Engineering, Karimnagar, Telangana on 25.08.2022 and 26.08.2022. Under the Ministry of Electronics And Information Technology (MEITY) the team CS-SIH-35 guided by Dr. K. Baskaran and Dr. C. Uma Rani have developed an application to control the screen time of education based gaming application for children"
    },
    {
        id:3,
        heading:"Team 2",
        "sub-head":"Grand Finale",
        pic:sih3,
        content_1:"",
        content_2:"The students have participated in the Grand finale of Smart India hackathon held in KIT’s college of Engineering, Kohapur, Maharashtra on 25.08.2022 and 26.08.2022. Under the Ministry Of Rural Development the team CS-SIH-31 guided by Dr. S. Pauline and Mr. V. Pradeep have developed a system which can read and analyze hand written text and convert it into normal editable text."
    },
];

export const sih20=[
    {
        id:1,
        heading:"Team 1",
        "sub-head":"Grand Finale",
        pic:sih4,
        link:"",
        content_1:"",
        content_2:"The students have participated in the Grand finale of Smart India hackathon held by online mode 0n 15.05.2020. Under the Ministry of Railways the team SIH-AD-3 guided by Dr.C.UmaRani have developed a system, which can non invasive , quick and cost effective way checking of Parcels in parcel offices by railways and leaseholders."
    },
]